import { FnaNeedsAnalysis } from "./FnaNeedsAnalysis";
import type { FormData, ChooseProduct } from "@ifa/utils";

interface FnaNeedsAnalysisPlaceholderProps {
  financialAnalysis?: FormData[];
  chooseProducts?: ChooseProduct[];
  sourceOrderId?: number;
}

export function FnaNeedsAnalysisPlaceholder({ financialAnalysis, chooseProducts, sourceOrderId }: FnaNeedsAnalysisPlaceholderProps) {
  return <FnaNeedsAnalysis financialAnalysis={financialAnalysis} chooseProducts={chooseProducts} sourceOrderId={sourceOrderId} />;
}
